import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { AccountCircle } from '@material-ui/icons';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import SecurityHeaders from '../../data/SecurityHeaders';
import { useParams } from 'react-router-dom';
import { Avatar } from '@mui/material';

const BountyUpdate = () => {
  const { id } = useParams();
  const [image, setImage] = useState(null);
  const [bountyTitle, setBountyTitle] = useState('');
  const [bountyDescription, setBountyDescription] = useState('');
  const [organizationId, setOrganizationId] = useState('');
  const [organizationId2, setOrganizationId2] = useState(''); // New field
  const [companyName, setCompanyName] = useState(''); // Renamed to match backend
  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const [p3, setP3] = useState('');
  const [p4, setP4] = useState('');
  const [payout, setPayout] = useState('');
  const [category, setCategory] = useState('');
  const [link, setLink] = useState('');
  const [uploadedDate, setUploadedDate] = useState(''); // New field
  const [startDate, setStartDate] = useState('');
  const [status, setStatus] = useState('');
  const [techStack, setTechStack] = useState('');
  const [deadline, setDeadline] = useState('');
  const [rating, setRating] = useState('');
  const [open, setOpen] = useState({ open: false, message: '', type: '' });

  const getBounty = async () => {
    try {
      const data = new FormData();
      data.append('id', id);
      const response = await axios.post('https://skillsuprise.com/get-bounty-details.php', data, SecurityHeaders);
      if (response.data.status === 'success') {
        const program = response.data.data;
        setBountyTitle(program.bounty_title || '');
        setBountyDescription(program.bounty_description || '');
        setOrganizationId(program.organization_id || '');
        setOrganizationId2(program.organization_id2 || '');
        setCompanyName(program.company_name || '');
        setP1(program.p1 || '');
        setP2(program.p2 || '');
        setP3(program.p3 || '');
        setP4(program.p4 || '');
        setPayout(program.payout || '');
        setCategory(program.category || '');
        setLink(program.link || '');
        setUploadedDate(program.uploaded_date || '');
        setStartDate(program.start_date || '');
        setStatus(program.status || '');
        setTechStack(program.tech_stack || '');
        setDeadline(program.deadline || '');
        setRating(program.rating || '');
        setImage(program.image || '');
      }
    } catch (error) {
      setOpen({ open: true, message: 'Failed to fetch bounty details', type: 'error' });
    }
  };

  useEffect(() => {
    getBounty();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const updateBounty = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      if (image) {
        data.append('image', image);
      }
      data.append('bounty_id', id);
      data.append('bounty_title', bountyTitle);
      data.append('bounty_description', bountyDescription);
      data.append('organization_id', organizationId);
      data.append('organization_id2', organizationId2 || '0');
      data.append('company_name', companyName); // Renamed to match backend
      data.append('p1', p1 || '0');
      data.append('p2', p2 || '0');
      data.append('p3', p3 || '0');
      data.append('p4', p4 || '0');
      data.append('payout', payout || '0');
      data.append('category', category);
      data.append('link', link);
      data.append('uploaded_date', uploadedDate || '');
      data.append('start_date', startDate);
      data.append('status', status);
      data.append('tech_stack', techStack);
      data.append('deadline', deadline);
      data.append('rating', rating || '0');

      const res = await axios.post('https://skillsuprise.com/update-bounties.php', data, SecurityHeaders);
      if (res.data.status === 'success') {
        setOpen({ open: true, message: res.data.message, type: 'success' });
      } else {
        setOpen({ open: true, message: res.data.message || 'Update failed', type: 'error' });
      }
    } catch (error) {
      setOpen({ open: true, message: 'Error updating bounty: ' + error.message, type: 'error' });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <div className="col-12">
        <Snackbar open={open.open} onClose={handleClose} autoHideDuration={4000}>
          <Alert
            severity={open.type === 'success' ? 'success' : 'error'}
            onClose={handleClose}
            variant="filled"
            className="col-12"
          >
            {open.message}
          </Alert>
        </Snackbar>
      </div>

      <div>
        <h2 className="mb-3 text-center my-3 text-primary">Update Bounty</h2>
        <div className="d-flex justify-content-center">
          <div className="card col-11 col-lg-8 col-sm-12 col-md-8 p-4 shadow rounded-3">
            <form onSubmit={updateBounty}>
              <div className="mb-3">
                <label htmlFor="image" className="form-label">Image</label>
                <Avatar
                            onClick={() => document.getElementById("fileInput").click()}
                            sx={{ width: 56, height: 56 }}
                            src={
                                image instanceof File
                                    ? URL.createObjectURL(image)
                                    : image
                            }
                        />
                        <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
              </div>

              <div className="mb-3">
                <label htmlFor="bounty_title" className="form-label">Bounty Title</label>
                <input
                  type="text"
                  value={bountyTitle}
                  className="form-control"
                  onChange={(e) => setBountyTitle(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="bounty_description" className="form-label">Description</label>
                <textarea
                  value={bountyDescription}
                  className="form-control"
                  onChange={(e) => setBountyDescription(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="organization_id" className="form-label">Organization ID</label>
                <input
                  type="number"
                  value={organizationId}
                  className="form-control"
                  onChange={(e) => setOrganizationId(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="organization_id2" className="form-label">Secondary Organization ID  </label>
                <input
                  type="number"
                  value={organizationId2}
                  className="form-control"
                  onChange={(e) => setOrganizationId2(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="company_name" className="form-label">Company Name</label>
                <input
                  type="text"
                  value={companyName}
                  className="form-control"
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="p1" className="form-label">P1  </label>
                <input
                  type="number"
                  value={p1}
                  className="form-control"
                  onChange={(e) => setP1(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="p2" className="form-label">P2  </label>
                <input
                  type="number"
                  value={p2}
                  className="form-control"
                  onChange={(e) => setP2(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="p3" className="form-label">P3  </label>
                <input
                  type="number"
                  value={p3}
                  className="form-control"
                  onChange={(e) => setP3(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="p4" className="form-label">P4  </label>
                <input
                  type="number"
                  value={p4}
                  className="form-control"
                  onChange={(e) => setP4(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="payout" className="form-label">Payout  </label>
                <input
                  type="number"
                  value={payout}
                  className="form-control"
                  onChange={(e) => setPayout(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="category" className="form-label">Category</label>
                <input
                  type="text"
                  value={category}
                  className="form-control"
                  onChange={(e) => setCategory(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="link" className="form-label">Link</label>
                <input
                  type="text"
                  value={link}
                  className="form-control"
                  onChange={(e) => setLink(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="uploaded_date" className="form-label">Uploaded Date  </label>
                <input
                  type="datetime-local"
                  value={uploadedDate}
                  className="form-control"
                  onChange={(e) => setUploadedDate(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="start_date" className="form-label">Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  className="form-control"
                  onChange={(e) => setStartDate(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="status" className="form-label">Status</label>
                <select
                  value={status}
                  className="form-control"
                  onChange={(e) => setStatus(e.target.value)}
                  required
                >
                  <option value="">Select Status</option>
                  <option value="open">Open</option>
                  <option value="closed">Closed</option>
                  <option value="in-progress">In Progress</option>
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="tech_stack" className="form-label">Tech Stack</label>
                <input
                  type="text"
                  value={techStack}
                  className="form-control"
                  onChange={(e) => setTechStack(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="deadline" className="form-label">Deadline</label>
                <input
                  type="date"
                  value={deadline}
                  className="form-control"
                  onChange={(e) => setDeadline(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="rating" className="form-label">Rating (1-5, Optional)</label>
                <input
                  type="number"
                  value={rating}
                  className="form-control"
                  min="1"
                  max="5"
                  onChange={(e) => setRating(e.target.value)}
                />
              </div>

              <button type="submit" className="btn btn-primary">Update Bounty</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BountyUpdate;